import axios from "src/service/axios_c";
import AuthConfig from "@system/config/auth";
import ResponseMaker from "./Auth/shippingAddress/responseMaker";
import { __remove, __set } from "../store/axios_indicator";
import Helper from "src/support/Helper";

class Auth {
  getShippingAddress = async (params = false) => {
    __remove("SHIPPING_ADDRESS_API_CALL");
    let res = [];
    await this.axiosCall(AuthConfig.SHIPPING_ADDRESS, params, "GET").then(
      (resHer) => {
        res = resHer.data;
      }
    );
    __remove("SHIPPING_ADDRESS_API_CALL");
    return new ResponseMaker(res).process().run().get();
  };
  getCustomerScopedInformation = async (params = false) => {
    let res = {};
    await this.axiosCall(
      AuthConfig.CUSTOMER_SCOPED_INFORMATION,
      params,
      "GET"
    ).then((resHer) => {
      res = resHer.data;
    });
    return res;
  };
  setDefaultShippingAddress = async (shipToAddressId) => {
    __remove("SET_DEFAULT_SHIPPING_ADDRESS_API_CALL");
    let res = [];
    if (shipToAddressId) {
      await this.axiosCall(AuthConfig.MAKE_SHIPPING_ADDRESS_DEFAULT, {
        shipToAddressId,
      }).then((resHer) => {
        res = resHer.data;
      });
    } else {
      await this.axiosCall(AuthConfig.SAVE_USER_PREFRENCE_URL, {
        preferenceType: "Default_ShipTo",
        preferenceValue: null,
      }).then((resHer) => {
        res = resHer.data;
      });
    }
    __remove("SET_DEFAULT_SHIPPING_ADDRESS_API_CALL");
    return res;
  };

  getUserVerification = async (params) => {
    __set('USER_VERIFICATION_API_CALL')
    let res = false;
    let reqHeader = { token: encodeURIComponent(params) };
    await this.axiosCall(AuthConfig.USER_VERIFICATION_URL, {}, 'post', reqHeader).then(
      (resHer) => {
        res = resHer.data;
      }
    ).catch(() => {
      __remove('USER_VERIFICATION_API_CALL')
    });
    __remove('USER_VERIFICATION_API_CALL')
    return res;
  }

  axiosCall = (url, data = {}, method = "post", header = {}) => {
    let config = {
      method: method,
      url: url,
      headers: Helper.getCommonHeader(method),
      data: data,
    };
    if (header) {
      config.headers = { ...config.headers, ...header }
    }
    if (config.method !== "post" && config.method !== "POST") {
      config.params = data;
    }
    return axios(config);
  };
}

export default Auth;
